// extracted by mini-css-extract-plugin
export var cardIcon = "_91-5";
export var cardIconUnframed = "_91-9";
export var checkboxCard = "_91-0";
export var checkboxCardSelected = "_91-4";
export var disabled = "_91-2";
export var interactive = "_91-1";
export var outerBorder = "_91-3";
export var spacerMedium = "_91-8";
export var spacerSmall = "_91-7";
export var spacerXsmall = "_91-6";